<script lang="ts">
	import { getTimezone } from '../cities';
	// import posthog from 'posthog-js';

	export let artistId: number;
	export let month: string;
	export let day: number;
	export let city: string;
	export let startTimestamp: number;
	export let url: string;
</script>

<!-- removed posthog tracking from the a class-->
<a
	href={url}
	target="_blank"
	class="group flex items-center py-2"
>
	<div class="w-[43.5px] text-center">
		<div
			class="flex h-[18px] w-full items-center justify-center rounded-t-[4px] bg-[#666666] p-0 text-[12px] font-bold uppercase text-white"
		>
			{month}
		</div>
		<div
			class=" flex h-[25.5px] w-full items-center justify-center rounded-b-[4px] bg-[#999999] px-1 py-0.5 text-[14.4px] font-bold text-white"
		>
			{day}
		</div>
	</div>
	<div class="ml-4">
		<p class="-mb-0.5 text-[13px] font-semibold text-black">{city}</p>
		<p class="text-[11px] font-semibold text-[#909090] group-hover:text-black">
			{new Date(startTimestamp).toLocaleDateString('en-GB', {
				weekday: 'long',
				day: 'numeric',
				month: 'long',
				year: 'numeric',
				timeZone: getTimezone(city)
			})}
		</p>
	</div>
</a>
